import { createContext, useContext } from "react"
import { OrgUnit } from "../models/OrgUnit"
import { ContextProps, DataForOrgUnitContext, RoleStatements, roleChecker } from "./commonOrgContext"

const TeamContext = createContext<DataForContext | undefined>(undefined)

export function TeamRoleProvider({ orgUnit, role, setOrgUnit, children }: ContextProps) {
  const context = ContextData({ orgUnit, role, setOrgUnit, children })

  return (
    <TeamContext.Provider value={context}>
      {children}
    </TeamContext.Provider>
  )
}

interface DataForContext {
  orgUnit?: OrgUnit
  canAdmin: roleChecker
  canCoordinate: roleChecker
  isMember: roleChecker
  canManageDonations: roleChecker
  flags: string[]
}

function ContextData({ orgUnit, role }: ContextProps): DataForContext {
  const { canAdmin, canCoordinate, isMember, canManageDonations } = RoleStatements(role)
  const flags = orgUnit?.flags ?? []

  const context: DataForContext = {
    orgUnit,
    canAdmin,
    canCoordinate,
    isMember,
    canManageDonations,
    flags
  }
  return context
}

export const useTeamRoleContext = () => {
  const context = useContext(TeamContext)
  return context as DataForOrgUnitContext
}
